import { render, staticRenderFns } from "./mediaFile.vue?vue&type=template&id=538d817c&scoped=true"
import script from "./mediaFile.vue?vue&type=script&lang=js"
export * from "./mediaFile.vue?vue&type=script&lang=js"
import style0 from "./mediaFile.vue?vue&type=style&index=0&id=538d817c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d817c",
  null
  
)

export default component.exports